import { io } from "socket.io-client";

const baseUrl = process.env.REACT_APP_SERVER;

export const initSocketConnection = (socketPath) =>
  io(`${baseUrl}${socketPath}`);

export const disconnectSocketConnection = (socket) => socket.disconnect();
